import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular/lazy';
import { PendingOrderService } from 'src/app/services/pending-order.service';
import { Clipboard } from '@capacitor/clipboard';

@Component({
    selector: 'app-reports-pending-orders',
    templateUrl: './reports-pending-orders.page.html',
    styleUrls: ['./reports-pending-orders.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportsPendingOrdersPage implements OnInit {

    pending_orders = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private pendingOrderService: PendingOrderService,
    ) { }

    ngOnInit() {
        this.pendingOrderService.getPendingOrders().then((pending_orders) => {
            if (pending_orders) {
                this.pending_orders = pending_orders;
            }
        })

    }

    copyToClipboard() {
        let orders = JSON.stringify(this.pending_orders);
        Clipboard.write({
            string: orders
        }).then(() => {
        this.presentAlert("Your pending order data has been copied to your clipboard", "");
        });
    }

    close() {
        this.modalController.dismiss();
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
